import "antd/dist/antd.css";
import "../../App.scss";

/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";

import { Button, message, Table } from "antd";
import moment from "moment";
import { CSVLink } from "react-csv";
import { useHistory } from "react-router-dom";

import { DownloadOutlined } from "@ant-design/icons";

import FiltersWrapper from "../../Components/FiltersWrapper/FiltersWrapper";
import TableUserInfoItem from "../../Components/TableUserInfoItem/TableUserInfoItem";
import { DATE_TIME_FORMAT } from "../../Utils/constants";
import { getNoAccountUser } from "../api/index";

const NoAccountUser = () => {
  const history = useHistory();

  const [userDetails, setUserDetails] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(async () => {
    setIsLoading(true);
    try {
      const fetchedUserDetails = await getNoAccountUser(page);
      if (fetchedUserDetails.code === 0) {
        setUserDetails(fetchedUserDetails?.result?.users);
        setTotal(Math.ceil(fetchedUserDetails?.result?.userCount));
      } else if (
        fetchedUserDetails.code === 401 ||
        fetchedUserDetails.status === 401
      ) {
        localStorage.clear();
        history.push("/");
        fetchedUserDetails?.message
          ? message.error(fetchedUserDetails?.message)
          : message.error("Something went wrong");
      } else {
        fetchedUserDetails?.message
          ? message.error(fetchedUserDetails?.message)
          : message.error("Something went wrong");
      }
    } catch (error) {
      error?.message
        ? message.error(error?.message)
        : message.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }

    return () => {
      setUserDetails([]);
    };
  }, [page]);

  // const onChange = (date, dateString) => {
  //   if (date) {
  //     console.log(date.format('MM-YYYY'));
  //     setDate(date.format('MM-YYYY'));
  //   } else {
  //     setDate(moment(new Date()).format('MM-YYYY'));
  //   }
  // }

  const displayUserDetails = () => {
    const onboardingObj = {
      dual: "Dual",
      fan_completed: "Fan",
      creator_completed: "Creator",
    };
    const tableData = userDetails.reduce((acc, eachDetails) => {
      return [
        ...acc,
        {
          key: eachDetails?._id,
          name: eachDetails?.name,
          onboarding: onboardingObj[eachDetails?.onboarding],
          email: eachDetails?.email,
          phone: eachDetails?.phone,
          createdAt: moment(eachDetails?.createdAt).format(DATE_TIME_FORMAT),
          profilePicUrl: eachDetails?.profilePicUrl,
        },
      ];
    }, []);

    const columns = [
      {
        title: "Creator",
        dataIndex: "name",
        key: "name",
        render: (_, record) => (
          <TableUserInfoItem
            name={record?.name}
            profilePic={record?.profilePicUrl}
            email={record?.email}
            phone={record?.phone}
            isCopyable
          />
        ),
      },
      {
        title: "Status",
        dataIndex: "onboarding",
        key: "onboarding",
      },
      {
        title: "Created On",
        dataIndex: "createdAt",
        key: "createdAt",
      },
    ];

    return (
      <>
        <Table
          columns={columns}
          dataSource={isLoading ? [] : tableData}
          loading={isLoading}
          pagination={{
            current: page,
            onChange: (p) => setPage(p),
            total,
            showSizeChanger: false,
            pageSize: 100,
          }}
          locale={{
            emptyText: isLoading ? "Loading..." : "No users found",
          }}
          scroll={{ x: "auto" }}
        />
      </>
    );
  };

  const headers = [
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Gender", key: "gender" },
    { label: "Profile Pic", key: "profilePicUrl" },
    { label: "Phone No.", key: "phone" },
    { label: "Onboarding status", key: "onboarding" },
    { label: "About", key: "about" },
    { label: "Profile created", key: "createdAt" },
    { label: "Facebook", key: "facebook" },
    { label: "Instagram", key: "instagram" },
    { label: "Linkedin", key: "linkedin" },
    { label: "Email verified", key: "isEmailVerified" },
    { label: "Account Deactivated", key: "isDeactivated" },
    { label: "Account hidden from discovery", key: "isHiddenFromDiscovery" },
    { label: "Twitter", key: "twitter" },
    { label: "Slug", key: "userSlug" },
    { label: "Youtube", key: "youtube" },
    { label: "Mongo Id", key: "_id" },
  ];

  return (
    <>
      <FiltersWrapper style={{ justifyContent: "end" }}>
        <CSVLink
          filename={`no_account_${new Date()}.csv`}
          data={userDetails}
          headers={headers}
        >
          <Button className="siteBtn grayBtn">
            <DownloadOutlined />
            Export CSV
          </Button>
        </CSVLink>
      </FiltersWrapper>

      {displayUserDetails()}
    </>
  );
};

export default NoAccountUser;
